import { apiSlice } from './apiSlice';
import { UPLOAD_URL } from '../constants';

export const utilsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        uploadImage: builder.mutation({
            query: (data) => ({
                url: UPLOAD_URL,
                method: 'POST',
                body: data,
            }),
        }),
        deleteImage: builder.mutation({
            query: (image) => {
                const imageName = typeof image === 'string' ? image : image?.imageName;
                if (!imageName) return {};
                const fileName = imageName.split('/').pop();
                return {
                    url: `${UPLOAD_URL}/${fileName}`,
                    method: 'DELETE',
                };
            },
        }),
    }),
});

export const { useUploadImageMutation, useDeleteImageMutation } = utilsApiSlice;
